// extracted by mini-css-extract-plugin
export default {"Overlay":"ApiResponseDisplay_Overlay__WHLY3","ResponseBox":"ApiResponseDisplay_ResponseBox__VzIDQ","Button":"ApiResponseDisplay_Button__J0s-3"};